import React from "react";
import latinize from 'latinize';
import HighlighterWords from 'react-highlight-words';

const HIGHLIGHT_STYLE_CLASS = 'highlighter';

function Highlighter(props) {

	return (
		<HighlighterWords
			highlightClassName={HIGHLIGHT_STYLE_CLASS}
			searchWords={props.terms && props.terms.split ? props.terms.split(' ') : [] }
			autoEscape={true}
			sanitize={latinize}
			textToHighlight={props.text}/>
	)
}

export default Highlighter